import {Controller} from "react-hook-form";
import React, {Fragment} from "react";
import Select from "react-select";

export const CommonDropdown = ({
                                   items, label, control, initialValue, styles, components, onChange, name, formatGroupLabel,
                                   rules, placeholder, isSearchable= false, isClearable = false,
                                   isMulti = false, readOnly = false, validate
                               }) =>
{
    const isReadOnly = readOnly === undefined ? false : readOnly;

    const getReadOnlyContent = (value, items) =>
    {
        if (value === null || value === undefined)
        {
            return null;
        }

        if (Array.isArray(value))
        {
            return value.reduce((acc, cur) =>
            {
                const entry = items.find(element => +element.value === +cur.value);

                if (entry === undefined)
                {
                    return acc === '' ? 'Unknown Relation ID ' + cur.value : acc + ', ' + 'Unknown Relation ID ' + cur.value;
                }
                else
                {
                    return acc === '' ? entry.label : acc + ', ' + entry.label;
                }
            }, '');
        }
        else
        {
            let label = value.label;

            if (value.label === undefined)
            {
                const targetItem = items.find(element => +element.value === +value.value);

                if (targetItem !== undefined)
                {
                    label = targetItem.label;
                }
                else
                {
                    label = "Unknown ID " + value.value;
                }
            }

            return label;
        }
    }

    const searchForItem = ( items, value ) =>
    {
        const searchItems = items[0]?.options !== undefined ? items.reduce((accum, current) =>
        {
            return (
                [...accum, ...current.options]
            )
        }, []) : items ;

        const targetItem = searchItems.filter((item) =>
        {
            if (+(item.value) === +(value.value))
            {
                return item;
            }
        });

        return targetItem ;
    }

    const getLabel = (value) =>
    {
        if (value === null)
        {
            return null;
        }

        let label = value.label;

        if (value.label === undefined)
        {
            const targetItem = searchForItem ( items, value )

            if (targetItem.length > 0)
            {
                label = targetItem[0].label;
            }
            else
            {
                label = "Unknown ID " + value.value;
            }
        }

        return label;
    }

    const findIt = ( data, v ) =>
    {
        let found = false ;

        if ( data[0]?.options !== undefined )
        {
            const flattened = data.reduce((accum, current) =>
            {
                return (
                    [ ... accum, ...current.options ]
                )
            }, []) ;

            found = v === null || v === undefined ? null : flattened.find((element) =>
            {
                return element.value === v.value
            });
        }
        else
        {
            found = v === null || v === undefined ? null : data.find((element) =>
            {
                return element.value === v.value
            });
        }

        return found ;
    }

    const initValue = (value, data) =>
    {
        let v = value;

        let found = findIt( data, v ) ;

        if (Array.isArray(value))
        {
            const entry = value.map((cur) =>
            {
                const entry = items.find(element => +element.value === cur.value);

                if (entry !== undefined)
                {
                    return {value: entry.value, label: entry.label}
                }
                else
                {
                    return {value: cur.value, label: 'Unknown Relation ID ' + cur.value}
                }
            })

            return entry;
        }
        else if (data === null || data === undefined || data.length === 0 || found === undefined)
        {
            return null;
        }
        else if (value === undefined || value === null || value.value === undefined || value.value === null)
        {
            return value;
        }
        else if (value.label !== undefined)
        {
            return value;
        }
        else
        {
            v = {value: value.value, label: getLabel(value)}
        }

        return v;
    }

    if (control === undefined)
    {
        return (
            <Fragment>
                { label !== undefined && <label className='col-form-label'>{label}</label>}
                {readOnly !== true && <Select
                    placeholder={placeholder}
                    onChange={onChange}
                    defaultValue={initValue(initialValue, items)}
                    options={items}
                    isSearchable={isSearchable}
                    isClearable={isClearable}
                    components={components}
                    isMulti={isMulti}
                    styles={styles}
                    formatGroupLabel={formatGroupLabel}/>}
                {isReadOnly === true && <input className='form-control' readOnly={readOnly} value={getLabel(value)}/>}
            </Fragment>
        )
    }
    else
    {
        const customStyles = {
            // For the select it self, not the options of the select
            container: (styles, {isDisabled}) => {
                return {
                    ...styles,
                    borderRadius: '.3rem',
                    border: '.5px solid #ced4da'
                }
            },
            // For the options
            singleValue: (styles, {isDisabled}) => {
                const color = isDisabled ? 'rgb(66, 139, 205)' : 'inherit';
                return {
                    ...styles,
                    color: color,
                    marginLeft: '7px',
                    cursor: isDisabled ? 'not-allowed' : 'default',
                };
            },
        };

        return (
            <Controller
                control={control}
                name={name}
                rules={rules}
                validate={validate}
                render={({
                             field: {onChange, value, name, ref},
                             fieldState: {invalid, isTouched, isDirty, error},
                             formState
                         }) => (
                    <Fragment>
                        { label !== undefined && <label className='col-form-label'>{label}</label>}
                        {<Select
                            styles={customStyles}
                            className={'react-select-neil'}
                            placeholder={placeholder}
                            onChange={onChange}
                            defaultValue={initValue(value, items)}
                            options={items}
                            ref={ref}
                            isDisabled={readOnly}
                            value={initValue(value, items)}
                            isSearchable={isSearchable}
                            isClearable={isClearable}
                            isMulti={isMulti}
                            formatGroupLabel={formatGroupLabel}/>}
                    </Fragment>
                )}/>
        )
    }
}
